import {
  ChangeDetectionStrategy,
  Component,
  input,
  Input,
  TemplateRef,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { ControlBase } from '../base/base.component';

@Component({
  selector: 'control-string',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NzInputModule, ReactiveFormsModule],
  template: `
    <nz-input-group
      [nzPrefix]="prefix()"
      [nzSuffix]="suffix()"
      [nzPrefixIcon]="prefixIcon()"
      [nzSuffixIcon]="suffixIcon()"
    >
      <input
        nz-input
        [class]="baseClasses"
        [formControl]="control()"
        [placeholder]="placeholder() || label()"
      />
    </nz-input-group>
  `,
})
export class ControlStringComponent extends ControlBase {
  prefix = input<string | TemplateRef<void> | undefined>();
  suffix = input<string | TemplateRef<void> | undefined>();
  prefixIcon = input<string | null | undefined>();
  suffixIcon = input<string | null | undefined>();
}
